import { render, staticRenderFns } from "./scrollPage.vue?vue&type=template&id=7772ac44&scoped=true&"
import script from "./scrollPage.vue?vue&type=script&lang=js&"
export * from "./scrollPage.vue?vue&type=script&lang=js&"
import style0 from "./scrollPage.vue?vue&type=style&index=0&id=7772ac44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7772ac44",
  null
  
)

export default component.exports